<style scoped>
</style>

<template lang='pug'>
  div
    .row
      .col.s12.m6
        //- pre {{user}}
        pre {{product.code}}
        pre availableInLocation {{deliverySchedule }}
        .btn-compound.bordered.width100(:class='{disabled: !canAddToCart}')
          a.btn-compound-item.waves-effect(@click='quantity--', :class='quantity === 1 ? "disabled": ""')
            i.material-icons remove
          span.btn-compound-item.grow.center-align {{quantity}}
          a.btn-compound-item.waves-effect(@click='quantity++')
            i.material-icons add
      .col.s12.m6
        a.btn.width100.waves-effect(@click='addToCart', :class='{disabled: !canAddToCart}')
          | Add to Cart

      //- p.red-text.col.s12 This product is not available in your chosen location

</template>
<script>
import Store from '../store'
export default {
  name: 'appcartbtn',
  props: ['product', 'variant', 'deliverySchedule'],
  data () {
    return {
      quantity: 1,
      giftWrapped: false,
      Store
    }
  },
  computed: {
    canAddToCart () {
      return (
        this.variant
        && this.variant.availableStock > 0
        && this.deliverySchedule
      )
    },
    availableInLocation () {
      return this.product.shop.location === 'Makati, Metro Manila, Philippines'
      // return this.product.shop.location === this.$store.state.cart.location
    }
  },
  methods: {
    addToCart () {
      let product = {
        ...this.variant,
        parent: {
          id: this.product.id,
          code: this.product.code,
          name: this.product.name
        },
        shop: {
          id: this.product.shop.id,
          code: this.product.shop.code,
          name: this.product.shop.name
        },
        supplier: {
          id: this.product.supplier.id,
          code: this.product.supplier.code,
          name: this.product.supplier.name
        }
      }
      this.$store.dispatch('cart/addToCart', {
        product: product,
        quantity: this.quantity,
        giftWrapped: this.giftWrapped,
        options: [
          {
            type: 'delivery:schedule',
            value: this.deliverySchedule
          }
        ]
      })
      .then(() => {
        this.$emit('added')
      })
      this.$snackbar.success(this.product.name + ' added to cart')
    }
  },
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-add-cart-btn.vue